import { Link } from "react-router-dom";
import { site } from "@/mocks/site";

export interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const schema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: site.name, item: "/" },
      ...items.map((item, index) => ({
        "@type": "ListItem",
        position: index + 2,
        name: item.label,
        ...(item.to ? { item: item.to } : {}),
      })),
    ],
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
      <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-2 text-xs md:text-sm text-foreground-500">
        <Link to="/" className="hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
          {site.name}
        </Link>
        {items.map((item, index) => (
          <span key={`${item.label}-${index}`} className="flex items-center gap-2">
            <i className="ri-arrow-right-s-line text-foreground-400"></i>
            {item.to ? (
              <Link to={item.to} className="hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-700 whitespace-nowrap">{item.label}</span>
            )}
          </span>
        ))}
      </nav>
    </>
  );
}